import React, { useState } from 'react';
import withLayout from '../../../hocs/Layout';
import { FormProvider, RHFFileField } from '../../../common/hook-form';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { Box, Button, Typography } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import DownloadIcon from '@mui/icons-material/Download';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { UploadFileOutlined } from '@mui/icons-material';
import { apiConstants, postMultipart } from '../../../common/constants';
import { toast } from "react-toastify";
import PageTitle from '../../../common/PageTitle';
import { getMerchant } from '../../../helpers/ReduxHelpers';
import { FONT, SIZE, WEIGHT } from '../../../styles/foundation/typography';
import { NAVY, WARNING } from '../../../styles/foundation/colors';
import {
    pageContainerSx, pageHeroSx, heroTitleSx, heroSubSx,
    uploadSectionSx, primaryBtnSx, secondaryBtnSx,
    helpTextSx, helpTextTypeSx, alertStripSx, btnRowSx,
} from '../../../styles/patterns';

const BulkDownloadPOD = (props) => {
    // Vertical split (set per menu entry): B2C = D2C, B2B = PTL
    const freightType = props.freightType || 'B2C';
    const vLabel = freightType === 'B2B' ? 'PTL' : 'D2C';
    const methodsBulkUpload = useForm({
        resolver: yupResolver(Yup.object().shape({ orderFile: Yup.mixed().required("Please Select a File") })),
        defaultValues: { orderFile: null }
    });
    const { handleSubmit: handleSubmitBulkUpload, reset } = methodsBulkUpload;
    const [fileLink, setFileLink] = useState([]);
    const [isUploadingFile, setIsUploadingFile] = useState(false);
    const [zipLink, setZipLink] = useState([]);
    const [mergedPdf, setMergedPdf] = useState([]);
    const merchant = getMerchant();
    const merchantId = merchant.id ? merchant.id : '';

    const onSubmitBulkUpload = async (data) => {
        setIsUploadingFile(true);
        try {
            let form = new FormData();
            form.append('file', data.orderFile[0]);
            await postMultipart(`${apiConstants.BULK_DOWNLOAD_POD}?isMerchantPannel=true&merchantoId=${merchantId}&shipmentType=${freightType}`, form).then(response => {
                if (response.data && response.data['excel'] && response.data['excel'].startsWith('https')) {
                    setFileLink(response.data['excel']);
                    setZipLink(response.data['zipFile']);
                    setMergedPdf(response.data['mergedPdf']);
                    toast("Successfully Uploaded!", { type: 'success' });
                    reset({ orderFile: null });
                } else {
                    toast(response?.data[3962], { type: 'error' });
                }
            }).catch(err => { console.error(err); setIsUploadingFile(false); toast(err?.response?.data?.message || "Error uploading file", { type: 'error' }); });
        } catch (err) {
            toast(err?.response?.data?.message || "Error uploading file", { type: 'error' });
        }
        setIsUploadingFile(false);
    }

    return (
        <Box sx={pageContainerSx}>
            <PageTitle subTitle="Upload an XLSX file with AWB numbers to download POD documents">{vLabel} Bulk POD Download</PageTitle>

            {/* <Box sx={pageHeroSx}>
                <Typography sx={heroTitleSx}>{vLabel} Proof of Delivery Download</Typography>
                <Typography sx={heroSubSx}></Typography>
            </Box> */}

            <Box sx={uploadSectionSx}>
                <Typography sx={{ fontFamily: FONT, fontSize: SIZE.md, fontWeight: WEIGHT.bold, color: NAVY, mb: 1.5 }}>
                    Upload AWB File
                </Typography>
                <Box sx={helpTextSx}>
                    <InfoOutlinedIcon sx={{ fontSize: 16, color: '#3783e7', mt: 0.2 }} />
                    <Typography sx={helpTextTypeSx}>
                        <strong>How it works:</strong> Upload an XLSX file containing AWB numbers.
                        POD documents will be generated and available as Excel, ZIP, or merged PDF.
                    </Typography>
                </Box>

                <Box sx={{ ...alertStripSx(WARNING), mb: 2 }}>
                    <WarningAmberIcon sx={{ fontSize: 16 }} />
                    <Typography sx={{ fontFamily: FONT, fontSize: SIZE['2xs'] }}>
                        Maximum 1500 AWBs can be uploaded at once.
                    </Typography>
                </Box>

                <FormProvider methods={methodsBulkUpload} onSubmit={handleSubmitBulkUpload(onSubmitBulkUpload)}>
                    <RHFFileField name="orderFile" accept={['xlsx']} />
                    <Box sx={{ ...btnRowSx, mt: 2 }}>
                        <LoadingButton startIcon={<FileUploadIcon />} type="submit" loading={isUploadingFile}
                            variant="contained" size="small" sx={primaryBtnSx}>
                            Upload
                        </LoadingButton>
                        {fileLink?.length === 0 && (
                            <Button variant="outlined" size="small" sx={secondaryBtnSx}
                                href={"https://djslb35m04okm.cloudfront.net/generate_labels.csv"} download="Order Upload Sample"
                                startIcon={<UploadFileOutlined sx={{ fontSize: 18 }} />}>
                                Sample Download
                            </Button>
                        )}
                        {fileLink?.length > 0 && (
                            <Button variant="outlined" size="small" sx={secondaryBtnSx}
                                href={fileLink} download="Download Excel" startIcon={<DownloadIcon sx={{ fontSize: 18 }} />}>
                                Download Excel
                            </Button>
                        )}
                        {zipLink?.length > 0 && (
                            <Button variant="outlined" size="small" sx={secondaryBtnSx}
                                href={zipLink} download="Download Zip" startIcon={<DownloadIcon sx={{ fontSize: 18 }} />}>
                                Download Zip
                            </Button>
                        )}
                        {mergedPdf?.length > 0 && (
                            <Button variant="outlined" size="small" sx={secondaryBtnSx}
                                href={mergedPdf} download="Download PDF" target="_blank" startIcon={<DownloadIcon sx={{ fontSize: 18 }} />}>
                                Download Merged PDF
                            </Button>
                        )}
                    </Box>
                </FormProvider>
            </Box>
        </Box>
    )
}
export default withLayout(BulkDownloadPOD);
